module.exports = __webpack_public_path__ + "0bbdfae6a728d9195292ee5ec30adb4f.svg";